import { VStack, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import VideoPlayerPublic from "./VideoPlayerPublic";
import { Silabus } from "../../const/types";
import cr from "../../lib/request";
import ComponentSpinner from "../spinner/ComponentSpinner";
import useScreenWidth from "../../lib/useGetScreenWidth";
import { useNavigate } from "react-router-dom";

type Props = {
  data: Silabus;
  nextIndex: number;
  maxIndex: number;
};

export default function ActiveSilabusWatch({
  data,
  nextIndex,
  maxIndex,
}: Props) {
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    if (data.id) {
      setLoading(true);
      const url = `api/course/getyoutubebysilabusid`;
      const payload = {
        silabus_id: data.id,
      };
      cr.post(url, payload)
        .then((r) => {
          if (r.status === 200) {
            setUrl(r.data.data);
          }
        })
        .catch((e) => {
          console.log(e);
          navigate("/mycourses");
          toast({
            title: "Tidak ada akses",
            description: e.response?.data?.message,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [data.id, navigate, toast]);

  const sw = useScreenWidth();
  const [activeSIlabusVideoHeight, setActiveSilabusVideoHeight] = useState<
    number | null
  >(null);

  useEffect(() => {
    let paddingContainer;
    let rasio;
    if (sw < 768) {
      paddingContainer = 27.1875;
      rasio = 0.562501958081393527;
    } else {
      paddingContainer = 36;
      rasio = 0.562488522783913533;
    }
    setActiveSilabusVideoHeight(sw * rasio - paddingContainer);
  }, [sw]);

  return (
    <VStack
      w={["100%", null, null, "70%"]}
      borderRadius={12}
      align={"stretch"}
      overflow={"hidden"}
      border={"1px solid var(--divider3)"}
    >
      {!loading && url ? (
        <VideoPlayerPublic
          url={url}
          data={data}
          nextIndex={nextIndex}
          maxIndex={maxIndex}
        />
      ) : (
        <ComponentSpinner
          flex={1}
          minH={[`${activeSIlabusVideoHeight}px`, null, null, "470px"]}
        />
      )}
    </VStack>
  );
}
